import { createContext, useContext } from "react";
import invariant from "tiny-invariant";
import type {
  AccessGroupSourcesDataContextProps,
  AccessGroupSourcesDataContextProviderProps,
} from "../types";

const AccessGroupSourcesDataContext =
  createContext<AccessGroupSourcesDataContextProps | null>(null);

AccessGroupSourcesDataContext.displayName = "AccessGroupSourcesDataContext";

export const useAccessGroupSourcesData = () => {
  const context = useContext(AccessGroupSourcesDataContext);
  invariant(
    context,
    "useAccessGroupSourcesData must be used within a AccessGroupSourcesDataContextProvider",
  );
  return context;
};

export function AccessGroupSourcesDataProvider({
  accessGroups,
  originalAccessGroupSources,
  children,
  recordType,
  recordId,
  areFormItemsEmbedded,
  canRemoveAllAccessGroups,
  isSyncing,
  syncingTooltip,
  addConfirmationDetails,
}: Readonly<AccessGroupSourcesDataContextProviderProps>) {
  return (
    <AccessGroupSourcesDataContext.Provider
      value={{
        accessGroups,
        originalAccessGroupSources,
        recordType,
        recordId,
        areFormItemsEmbedded,
        canRemoveAllAccessGroups,
        isSyncing: isSyncing,
        syncingTooltip,
        addConfirmationDetails,
      }}
    >
      {children}
    </AccessGroupSourcesDataContext.Provider>
  );
}
